/**
 * The "New on your site, not shared yet" line on Reach → Calendar. Titles are
 * kept apart with " · ", never "a, b and c": page titles like "For company and
 * brand websites" made the run-on sentence unreadable (backlog 1b60aedf). The
 * home page ("/") is "Home", not its title. When the empty week's "Share a
 * page" list shows the pages just below, they're counted, not listed twice.
 */
export interface UnsharedItem {
  title: string;
  path?: string;
}

const SHOWN = 3;

function list(items: string[]): string {
  const shown = items.slice(0, SHOWN);
  const rest = items.length - shown.length;
  return [...shown, ...(rest > 0 ? [`+${rest}`] : [])].join(' · ');
}

export function unsharedLine(
  articles: UnsharedItem[],
  pages: UnsharedItem[],
  {
    paused = false,
    pagesListedBelow = false,
  }: { paused?: boolean; pagesListedBelow?: boolean } = {}
): string {
  const parts: string[] = [];
  if (paused) parts.push('Share new articles is paused.');
  if (articles.length) {
    const n = articles.length;
    parts.push(
      `${n} ${n === 1 ? 'article' : 'articles'}: ${list(articles.map((a) => `“${a.title}”`))}.`
    );
  }
  if (pages.length) {
    const n = pages.length;
    const word = n === 1 ? 'page' : 'pages';
    parts.push(
      pagesListedBelow
        ? `${n} ${word}, listed below.`
        : `${n} ${word}: ${list(pages.map((p) => (p.path === '/' ? 'Home' : p.title)))}.`
    );
  }
  return parts.join(' ');
}
